// extracted by mini-css-extract-plugin
module.exports = {"content":"ComingSoonModal_content__312iw","dialog":"ComingSoonModal_dialog__yN8c7","body":"ComingSoonModal_body__1wDbB"};